
import { useState, useEffect } from "react";
import { Wrapper } from "./Wrapper";

const WrapperWithRecovery = (props) => {
  const [key, setKey] = useState(0);

  useEffect(() => {
    const handleFatalError = (e) => {
      e.preventDefault();
      const msg = e.reason.message;
      console.log("[fatal error]", msg);
      if (
        msg.includes("setCodecPreferences") ||
        msg.includes("RTCRtpTransceiver")
      ) {
        console.warn("detected webrtc crash. remounting...");

        setKey((k) => k + 1);
      }
    };
    window.addEventListener("error", handleFatalError);
    window.addEventListener("unhandledrejection", handleFatalError);
    return () => {
      window.removeEventListener("error", handleFatalError);
      window.removeEventListener("unhandledrejection", handleFatalError);
    };
  }, []);

  return <Wrapper key={key} initialSettings={props.settings} />;
};
export default WrapperWithRecovery; 